<template>
  <transition name="fade">
    <div
      v-if="props.show"
      class="select-auto"
    >
      <div
        class="absolute w-screen h-screen bg-black opacity-70 inset-0 z-10"
        @click.stop="onModalToggle"
      />
      <div class="absolute inset-0 w-screen h-screen flex items-center justify-center">
        <div
          class="w-screen mx-2 xl:min-w-[600px] xl:max-w-2xl p-3 relative xl:mx-auto my-auto shadow-lg bg-white z-10"
        >
          <div >
            <div class="text-center p-3 flex-auto justify-center leading-6">
              <h2 class="text-3xl font-bold text-black">Canvas Dimensions</h2>
              <div class="flex flex-wrap space-around justify-center">
                <div class="flex bg-gray-300 py-1 px-4 md:mr-2 justify-center items-center text-center">
                  <div class="min-w-[56px]">Width</div>
                  <input
                    aria-label="Grid width in feet"
                    v-model="gridWidthFt"
                    class="w-12 h-8 mx-1 text-center select-text px-1"
                    type="number"
                    min="0"
                  >ft
                  <input
                    aria-label="Grid width in inches"
                    v-model="gridWidthIn"
                    class="w-12 h-8 mx-1 text-center select-text px-1"
                    type="number"
                    min="0"
                  >in
                </div>

                <div
                  class="flex bg-gray-300 py-1 px-4 justify-center items-center text-center"
                >
                  <div class="min-w-[56px]">Height</div>
                  <input
                    aria-label="Grid height in feet"
                    v-model="gridHeightFt"
                    class="w-12 h-8 mx-1 text-center select-text px-1"
                    type="number"
                    min="0"
                  >ft
                  <input
                    aria-label="Grid height in inches"
                    v-model="gridHeightIn"
                    class="w-12 h-8 mx-1 text-center select-text px-1"
                    type="number"
                    min="0"
                  >in
                </div>
              </div>
            </div>
            <div class="p-3 text-center space-x-4 md:block">
              <button
                aria-label="Update grid size"
                class="mb-2 md:mb-0 bg-black px-5 py-2 tracking-wider text-white hover:bg-gray-800 rounded-full"
                @click="updateGridSize"
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { FOOT_IN_PIXELS, INCH_IN_PIXELS } from '~/composables/grid/constants'

const store = useGridStore()
const modalStore = useModalStore();
const gridWidthFt = ref(store.gridSize.width.ft)
const gridWidthIn = ref(store.gridSize.width.in)
const gridHeightFt = ref(store.gridSize.height.ft)
const gridHeightIn = ref(store.gridSize.height.in)

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['modalToggle'])

const updateGridSize = () => {
  const gridWidthPx = (gridWidthFt.value * FOOT_IN_PIXELS) + (gridWidthIn.value * INCH_IN_PIXELS)
  const gridHeightPx = (gridHeightFt.value * FOOT_IN_PIXELS) + (gridHeightIn.value * INCH_IN_PIXELS)

  store.setGridSize(gridWidthPx, gridHeightPx)
  modalStore.handleSuccess(ModalType.GridSize);
}

const onModalToggle = () => {
  emit('modalToggle')
}
</script>

<style>
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 300ms ease-out;
}
</style>
